import React,{useState} from 'react'
import styles from '../checkout/ccdetails.module.scss'
import { useRouter } from 'next/router'
import endpoints from '../../../utility/endpoints';
import axios from 'axios';
import { IoIosArrowRoundForward, IoIosArrowRoundBack } from "react-icons/io"

function CCDetails({ onNext, onPrevious }) {
    const router = useRouter()
    const [businessowner, setBusinessowner] = useState('');
    const [countrycode, SetCountrycode] = useState('');
    const [tocountrycode, SetToCountrycode] = useState('');
    const [glaccount, SetGlaccount] = useState('');
    const [costcenterowner, SetCostcenterowner] = useState('');
    const [tocostcenter,SetToCostcenter] = useState('');
    const [submitForm, setSubmitForm] = React.useState(false);	



      const onFromSubmit = async () => {

        let authCheck = JSON.parse(localStorage.getItem("auth")).data;
       {/* if (!businessowner || !countrycode || !tocountrycode || !glaccount || !costcenterowner || !tocostcenter) {	
          setSubmitForm(true);	
        }	
        else{*/}
              let auth = await JSON.parse(localStorage.getItem("auth")).data;
              axios({
                method: "POST",
                url: `${endpoints.baseUrl}/twin/createCartFormDataEntry`,
                headers: {
                  Authorization: `${auth.accessToken}|${auth.email}`,
                },
                data: {
                 "employeeTwinID":"",
                  "Business_owner" : businessowner,
                  "Country_code" : countrycode,
                  "GL_Account" : glaccount,
                  "Cost_centre_owner" : costcenterowner,
                  "To_country_code" : tocountrycode,
                  "To_cost_centre" : tocostcenter,
                },
              }).then((resp) => {
                if (resp.data.code == 403) {
                 // setLoading(false)
                 
                } 
                else if (resp.data.code == 200  || resp.data.code == 201) {
                
                    
                        // router.push('/ETComments');
                        if (typeof onNext === 'function') {
                            onNext(); // Call onNext if it's a function
                        }
                      
                  
                } 
                else if (resp.data.code == 400) {
                
                }
              });
            
          //}
      
      };

    return (
        <div className={styles.cc_details_bg}>
            <div className={styles.cc_details_bg_inner}>
                <p className={styles.CC_main_heading}>Add CC Details</p>
                <div className={styles.cc_details_container}>
                    <div className={styles.cc_details_business}>
                        <div className={styles.cc_label_input_content}>
                            <label className={styles.cc_details_label}> Business Owner </label>
                            <input type='text' className={styles.cc_details_input} 
                             value={businessowner}
                             onChange={(e) => setBusinessowner(e.target.value)}
                             name="etname"/>
                        </div>
                        <div className={styles.cc_label_input_content}>
                            <label className={styles.cc_details_label}> GL Account </label>
                            <input type='text' className={styles.cc_details_input} 
                             value={glaccount}
                             onChange={(e) => SetGlaccount(e.target.value)}
                             name="glaccount"/>
                        </div>
                        <div className={styles.cc_label_input_content}>
                            <label className={styles.cc_details_label}> To Country Code </label>
                            <input type='text' className={styles.cc_details_input} 
                            value={tocountrycode}
                            onChange={(e) => SetToCountrycode(e.target.value)}
                            name="tocountrycode"/>
                        </div>
                    </div>
                    <div className={styles.cc_details_code}>
                        <div className={styles.cc_label_input_content}>
                            <label className={styles.cc_details_label}> Country Code </label>
                            <input type='text' className={styles.cc_details_input} 
                            value={countrycode}
                            onChange={(e) => SetCountrycode(e.target.value)}
                            name="countrycode"/>
                        </div>
                        <div className={styles.cc_label_input_content}>
                            <label className={styles.cc_details_label}> Cost Centre Owner </label>
                            <input type='text' className={styles.cc_details_input} 
                            value={costcenterowner}
                            onChange={(e) => SetCostcenterowner(e.target.value)}
                            name="costcenterowner"/>
                        </div>
                        <div className={styles.cc_label_input_content}>
                            <label className={styles.cc_details_label}> To Cost Centre </label>
                            <input type='text' className={styles.cc_details_input} 
                             value={tocostcenter}
                             onChange={(e) => SetToCostcenter(e.target.value)}
                             name="tocostcenter"/>
                        </div>
                    </div>
                </div>
                {/* <div className={styles.cc_details_btn_content}>
                    <button className={styles.cc_details_btn}  onClick={onFromSubmit}>
                        Proceed to hire <IoIosArrowRoundForward className={styles.cc_arrow_btn} />
                    </button>
                </div> */}
                <div className={styles.cc_details_btn_content}>
                    <button className={styles.cc_details_btn} onClick={onPrevious}>
                        <IoIosArrowRoundBack className={styles.cc_arrow_btn} />Previous
                    </button>
                    <button className={styles.cc_details_btn} onClick={onFromSubmit}>
                        Proceed to hire <IoIosArrowRoundForward className={styles.cc_arrow_btn} />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CCDetails
